import axios from "axios";

const TOKEN_KEY = "tbts_admin_token";
const EXPIRES_KEY = "tbts_admin_expires";

export function saveSession({ access_token, expires_at }) {
  try {
    localStorage.setItem(TOKEN_KEY, access_token);
    if (expires_at) localStorage.setItem(EXPIRES_KEY, expires_at);
  } catch {
    /* localStorage unavailable */
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EXPIRES_KEY);
  } catch {
    /* ignore */
  }
}

export function getToken() {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    const expiresAt = localStorage.getItem(EXPIRES_KEY);
    if (expiresAt) {
      const ts = Date.parse(expiresAt);
      if (Number.isFinite(ts) && ts <= Date.now()) {
        clearSession();
        return null;
      }
    }
    return token;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!getToken();
}

let interceptorsAttached = false;

export function attachAuthInterceptors(onUnauthorized) {
  if (interceptorsAttached) return;
  interceptorsAttached = true;

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        clearSession();
        if (typeof onUnauthorized === "function") onUnauthorized();
      }
      return Promise.reject(error);
    }
  );
}
